import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { EventManagerPlugin } from '@angular/platform-browser';

/**
 * {@link https://angular.dev/api/platform-browser/EventManagerPlugin | EventManagerPlugin} for `.prevent` —
 * declarative `preventDefault()` in templates, same extensibility model as `keydown.enter`.
 * Registered via {@link https://angular.dev/api/platform-browser/EVENT_MANAGER_PLUGINS | EVENT_MANAGER_PLUGINS}.
 *
 * @example
 * ```html
 * <div (dragover.prevent)="onDragOver()" (drop.prevent)="onDrop($event)"></div>
 * ```
 *
 * @see {@link https://angular.dev/guide/templates/event-listeners#extend-event-handling | Extend event handling}
 */
@Injectable()
export class PreventDefaultEventPlugin extends EventManagerPlugin {
    constructor(@Inject(DOCUMENT) doc: Document) {
        super(doc);
    }

    override supports(eventName: string): boolean {
        return eventName.split('.').includes('prevent');
    }

    override addEventListener(
        element: HTMLElement,
        eventName: string,
        handler: Function
    ): Function {
        const wrapped = (event: Event) => {
            event.preventDefault();
            handler(event);
        };

        return this.manager.addEventListener(
            element,
            eventName.replace('.prevent', ''),
            wrapped
        );
    }
}
